
/// <reference types="jquery" />

declare function fncSweetAlertToast(type: 'success' | 'error' | 'warning' | 'info' | 'question', text: string): void;
declare function fncSweetAlert(type: string, text: string, url?: string | null): Promise<any>;
declare function fncNotie(type: number, text: string): void;

interface SearchResponse {
  status?: number;
  length: number;
  forEach(callback: (value: any, index: number, array: any[]) => void): void;
  [index: number]: {
    img_product: string;
    name_product: string;
    user_credential_password?: string;
    id_user: number;
    id_password: number;
    url_password?: string;
    url_product: string;
  };
}


(function ($) {
  'use strict'
  $(document).ready(function () {

    $("#copy_to_clipboard").on('click', function (e: JQuery.ClickEvent) {
      e.preventDefault();
      var password = (document.getElementById('generated-password') as HTMLInputElement).value;
      navigator.clipboard.writeText(password);

      var el = document.createElement("div");
      el.classList.add('px-2');
      el.classList.add('py-2');
      el.classList.add('rounded');
      el.classList.add('border');
      el.classList.add('border-info');
      el.classList.add('text-info');
      el.innerHTML = "<i class='fa fa-check'></i> Contraseña generada copiada al portapapeles";
      const msgEl = document.getElementById("msg");
      if (msgEl) {
        msgEl.innerHTML = "";
        msgEl.appendChild(el);
        el.style.display = "block";
      }

      $("#producto").val("");
      $("#urlProduct").val("");
      $("#imgProduct").val("");
      $(".changePicture").attr("src", "views/assets/img/template/image.png");
    });


    $("#kt_app_sidebar_toggle").on('click', function () {
      if ($(this).hasClass("active")) {
        localStorage.setItem('sidebar', 'true');
      } else {
        localStorage.setItem('sidebar', 'false');
      }
    });

    if (localStorage.getItem("sidebar") && localStorage.getItem("sidebar") == 'false') {
      $("#kt_app_sidebar_toggle").addClass("active");
      $("#kt_app_body").attr("data-kt-app-sidebar-minimize", "on");
    }

    $("a.menu-link").each(function (this: HTMLAnchorElement) {
      if ($(this).attr("href") === localStorage.getItem("rutaActual")) {
        $(this).addClass("active");
        $(this).closest(".menu-accordion").addClass("hover show");
        var menuSub = $(this).closest(".menu-sub");
        menuSub.addClass("show");
        menuSub.css("display", "block");
        menuSub.css("overflow", "visible");
        menuSub.prev(".menu-link").addClass("active");
      }
    });

    $("a.menu-link .active").on('click', function (e: JQuery.ClickEvent) {
      $(e.target).removeClass("active");
    });
  });
})(jQuery);

$(document).on("click", ".removeItem", function (this: HTMLElement) {
  var idItem = $(this).attr("idItem") ?? '';
  var table = $(this).attr("table") ?? '';
  var suffix = $(this).attr("suffix") ?? '';
  var deleteFile = $(this).attr("deleteFile") ?? '';
  var page = $(this).attr("page") ?? '';

  fncSweetAlert("confirm", "Are you sure to delete this record?", null).then(resp => {
    if (resp) {
      var data = new FormData();
      data.append("idItem", idItem);
      data.append("table", table);
      data.append("suffix", suffix);
      data.append("token", localStorage.getItem("token_user") ?? '');
      data.append("deleteFile", deleteFile);

      $.ajax({
        url: "ajax/ajax-delete.php",
        method: "POST",
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        success: function (response: string) {
          if (response == "200") {
            fncSweetAlert(
              "success",
              "The record has been successfully deleted",
              "/" + page
            );
          } else {
            fncNotie(3, "error deleting the record");
          }
        }
      });
    }
  });
});
